import { Link } from "react-router";
import React, { PropTypes } from "react";
import validate from "validate.js";
import notificationSrc from "../../assets/img/notification-bell.png";

const LogoutLink = ({
  onClick,
  user,
  showNotifications,
  notificationsCount,
}) => (
  <li
    style={{
      float: "right",
    }}
  >
    {showNotifications && (
      <Link
        to={"/notifications"}
        style={{
          position: "relative",
          marginRight: "25px",
        }}
      >
        {!!notificationsCount && (
          <div
            style={{
              position: "absolute",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "red",
              right: "3px",
            }}
          />
        )}
        <img
          style={{ width: "25px", height: "25px", marginBottom: "-5px" }}
          src={notificationSrc}
          alt="notification-bell"
        />
      </Link>
    )}
    <Link to="/users/profile" style={{ color: "white", marginRight: "25px" }}>
      {user &&
        `${validate.capitalize(user.first_name)} ${validate.capitalize(
          user.last_name
        )} `}
    </Link>
    <a href="javascript:void(0)" onClick={onClick}>
      LOGOUT
    </a>
  </li>
);

LogoutLink.PropTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
};

export default LogoutLink;



// WEBPACK FOOTER //
// ./src/components/Navbar/LogoutLink.jsx